import { alpha } from "@mui/material";

export const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
  },
  tabs: {
    pt: 1,
    "& .MuiTabs-indicator": {
      display: "flex",
      justifyContent: "center",
      borderRadius: "5px 5px 0 0",
      p: 0.2,
    },
    "& button": {
      textTransform: "none",
    },
    borderBottom: 1,
    borderColor: "divider",
    backgroundColor: "transparent",
    width: "100%",
    "& .MuiTabs-flexContainer": {
      gap: 2.5,
    },
    "& button.Mui-selected": {
      backgroundColor: "transparent",
    },
  },
  buttonRefresh: (loading) => ({
    color: theme.palette.text.textContrast,
    borderColor: theme.palette.text.main,
    minWidth: "25px",
    padding: "10px",
    lineHeight: 1,
    "& .rotating": {
      animation: "spin 1s linear infinite",
    },
    "@keyframes spin": {
      "0%": { transform: "rotate(0deg)" },
      "100%": { transform: "rotate(-360deg)" },
    },
  }),
  boxTab: {
    display: "flex",
    alignItems: "center",
    gap: 1,
    fontSize: "1rem",
  },
  boxLoading: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "500px",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
  },
  textField: {
    width: "100%",
    maxWidth: 500,
  },
  filterBox: {
    display: "flex",
    width: "100%",
    gap: { xs: 1.5, md: 1 },
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    backgroundColor: theme.palette.background.paper,
    padding: 1.5,
    borderRadius: 1,
  },
  filterStack: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 1,
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  autocompleteBox: {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 2,
    width: "100%",
    maxWidth: 800,
    flex: 1,
  },
  actionsBox: {
    display: "flex",
    gap: 1,
    width: "100%",
    justifyContent: {
      xs: "center",
      sm: "flex-end",
      md: "flex-end",
    },
    flex: 0.5,
  },
  buttonImport: {
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },
  buttonNew: {
    color: theme.palette.text.main,
    borderColor: theme.palette.text.main,
  },
});

export const chipStyles = (theme) => (severity) => ({
  backgroundColor: alpha(theme.palette[severity].main, 0.2),
  color:
    theme.palette.mode === "dark"
      ? theme.palette[severity].light
      : theme.palette[severity].dark,
  fontWeight: "bold",
  "&.MuiChip-root": { borderRadius: 1 },
  "&.MuiChip-root .MuiChip-label": { marginTop: "2px" },
});
